import ProductIcon from '../../../utils/ProductIcon';

export function WpdCheckoutSubProductList({ bundleProducts, product }) {
	const isMonthly = +product?.item_number?.options?.price_id === 5;

	return (
		<div className="WpdCheckoutSubProductList">
			{bundleProducts?.map((bundleItem, i) => (
				<div
					className={`WpdCol ${i >= bundleProducts.length - 1 ? 'border-bottom-0' : ''} ${i === bundleProducts.length - 1 ? 'active-border-btm-500 xcloud-full' : ''}`}
					key={i}
					data-key={i}
				>
					<div className="WpdCheckoutSubProduct">
						<div className="WpdCheckoutProductInfo">
							<span className="WpdCheckoutProductIcon">
								<ProductIcon
									icon={bundleItem.icon}
									name={bundleItem.name}
								/>
							</span>
							<span className="WpdCheckoutProductDetails">
								<h4 className="wp-checkout-font-base WpdCheckoutProductTitle">
									{bundleItem.name}
								</h4>
								<p className="WpdCheckoutProductSubTitle">
									{bundleItem.priceName}
								</p>
							</span>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
